/**
 * As abas da planilha de configuração da empresa (2026-10-10) — espelho
 * de `core/company_config/spreadsheet.py::SHEETS`: a CHAVE estável (o
 * `catalog_kind` de cada linha do recibo da importação) e o NOME PT-BR da
 * aba, na ordem do formato. A paridade é travada por
 * `tests/test_company_config_sheets_parity.py`, que lê este arquivo.
 *
 * O recibo por linha mostra a aba pelo nome que a pessoa vê na planilha,
 * nunca pela chave interna.
 */

export const COMPANY_CONFIG_SHEETS = {
  company: "Empresa",
  brands: "Marcas",
  competitors: "Concorrentes",
  channels: "Canais",
  vehicles: "Veículos",
  publisher_tiers: "Porte do publicador",
  publisher_groups: "Grupos de publicador",
  publishers: "Publicadores",
  theme_groups: "Temas",
  themes: "Subtemas",
  spokespersons: "Porta-vozes",
  key_messages: "Mensagens-chave",
  citation_tags: "Citação no título",
  focus_terms: "Foco",
  classification_terms: "Termos de classificação",
  rules: "Premissas",
  prompts: "Textos de prompt"
} as const;

export type CompanyConfigSheetKey = keyof typeof COMPANY_CONFIG_SHEETS;

/** O nome da aba pra uma chave do recibo. Chave que o formato não
 *  conhece (recibo de uma versão futura) sai crua — melhor que sumir. */
export function companySheetName(key: string | null): string {
  if (key === null) return "—";
  return key in COMPANY_CONFIG_SHEETS
    ? COMPANY_CONFIG_SHEETS[key as CompanyConfigSheetKey]
    : key;
}
